<template>
  <div>
    <table v-once v-bind:id=tableId class="dataTable table table-striped table-bordered" width="100%" cellspacing="0">
      <thead>
      <tr>
        <th>Bezeichnung</th>
        <th>Kategorie</th>
        <th>Link</th>
      </tr>
      </thead>
    </table>

    <div>
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
  /* global $ */
  import FileService from '../services/FileService'

  export default {
    name: 'FileCollectionTable',
    props: ['id', 'context'],
    data () {
      return {
        // eslint-disable-next-line no-undef
        tableId: (this.$props.id !== undefined) ? 'dTable_' + this.$func.uuid() + '_' + this.$props.id : 'dTable_' + this.$func.uuid()
      }
    },
    methods: {},
    computed: {},
    async mounted () {
      await this.$store.dispatch('selectize/fetchFileCategories')

      // eslint-disable-next-line no-unused-vars
      var router = this.$router
      var tableId = this.tableId
      var path = '/' + this.$props.context + '/' + this.$props.id + '/filecollection'
      var self = this
      var store = (this.$store)

      $(document).ready(function () {
        // eslint-disable-next-line no-undef
        var editor = new $.fn.dataTable.Editor({
          ajax: {
            create: self.$func.addAuth({
              type: 'POST',
              url: path + '/'
            }),
            edit: self.$func.addAuth({
              type: 'PUT',
              url: path + '/_id_/'
            }),
            remove: self.$func.addAuth({
              type: 'DELETE',
              url: path + '/_id_/',
              deleteBody: false
            }),
            upload: self.$func.addAuth({
              type: 'POST',
              url: '/file/?origin=' + path
            })
          },
          idSrc: 'id',
          table: '#' + tableId,
          fields: [{
            label: 'Bezeichnung:',
            name: 'sBezeichnung'
          }, {
            label: 'Kategorie:',
            name: 'oFileCategory',
            type: 'selectize',
            closeAfterSelect: true,
            opts: {
              maxItems: 1,
              valueField: 'id',
              searchField: ['sBezeichnung'],
              placeholder: 'Kategorie wählen ...',
              preload: true,
              options: [],
              sortField: [{
                field: 'sBezeichnung',
                direction: 'asc'
              }, {
                field: '$score'
              }],
              create: false,
              render: {
                option: function (data, escape) {
                  return '<div>' + escape(data.sBezeichnung) + '</div>'
                },
                item: function (item, escape) {
                  return '<div>' + escape(item.sBezeichnung) + '</div>'
                }
              },
              load: function (query, callback) {
                callback(store.getters['selectize/getFileCategories'])
              }
            }
          }, {
            label: 'Datei:',
            name: 'fDatei',
            type: 'upload',
            display: function (fileId) {
              if (!$.isNumeric(fileId)) {
                return fileId.toString().split('###')[0]
              }

              var rowData = $('#' + tableId).DataTable().row(editor.modifier()).data()
              return rowData.oDatei.sFilename
            },
            uploadText: 'Datei auswählen',
            clearText: 'entfernen',
            noFileText: 'Keine Datei vorhanden',
            dragDropText: 'oder die Datei hier hinein ziehen.'
          }
          ]
        })

        $('#' + tableId).DataTable({
          ajax: self.$func.addAuth({
            url: path + '/',
            type: 'GET'
          }),
          scrollX: true,
          scrollY: '300px',
          scrollCollapse: true,
          columns: [

            {
              class: 'center',
              data: 'sBezeichnung'
            },
            {
              class: 'center',
              data: null,
              render: function (data, type, row) {
                // eslint-disable-next-line no-undef
                if (isset(data.oFileCategory)) {
                  return (data.oFileCategory.sBezeichnung)
                }
                return '-'
              }
            },
            {
              class: 'center',
              data: null,
              render: function (data, type, row) {
                // eslint-disable-next-line no-unused-vars
                var link = '<span class="dt-download pointer">' + data.oDatei.sFilename + '<i style="margin-left: 1rem" class="fas fa-download fa-lg"></i></span>'
                return link
              }
            }
          ],
          buttons: [
            {
              extend: 'create',
              editor: editor
            },
            {
              extend: 'edit',
              editor: editor
            },
            {
              extend: 'remove',
              editor: editor
            }
          ]
        })

        $('#' + tableId).on('click', '.dt-download', function (e) {
          e.preventDefault()
          var tr = $(this).closest('tr')
          var row = $('#' + tableId).DataTable().row(tr)
          // var id = row.data().id
          FileService.download(row.data().oDatei)
        })

        $('#' + tableId + ' tbody').on('dblclick', 'tr', function () {
          editor
            .edit(this)
            .title($.fn.dataTable.Editor.defaults.i18n.edit.title)
            .buttons({
              label: $.fn.dataTable.Editor.defaults.i18n.edit.submit,
              className: 'btn btn-primary',
              fn: function () {
                editor.submit()
              }
            })
        })
      })
    }
  }
</script>
<style>

</style>
